import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./AllMeds.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { addToCart, addToCartAsync } from "../../Features/Cart/cartSlice.js"; // Adjust path if needed

import {
  FaThLarge,
  FaAmbulance,
  FaPills,
  FaUserMd,
  FaBaby,
  FaStethoscope,
  FaUser,
  FaDumbbell,
  FaLeaf,
  FaFlask,
  FaCapsules,
  FaSearch,
} from "react-icons/fa";
import df from '../../Assets/Brands/default.png'

const AllMeds = () => {
  const USER = useSelector((state) => state.user.user?._id);
  const [medicines, setMedicines] = useState([]);
  const dispatch = useDispatch();
  const [visibleMedicines, setVisibleMedicines] = useState(8);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [sortBy, setSortBy] = useState("name");
  const [selectedPriceRange, setSelectedPriceRange] = useState("all");
  const [isScrolled, setIsScrolled] = useState(false);
  const stickyRef = useRef(null);
  const [brandFilter, setBrandFilter] = useState("all");
  const [salt, setSalt] = useState("all");
  const [sortOrder, setSortOrder] = useState("default");
  const [discountSort, setDiscountSort] = useState("default"); // New state for discount sorting
  const cartItems = useSelector((state) => state.cart.items);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const searchRef = useRef(null);

  const categories = [
    { id: "all", name: "All Categories", icon: <FaThLarge /> },
    { id: "ALLOPATHIC", name: "Allopathic", icon: <FaCapsules /> },
    { id: "AYURVEDA", name: "Ayurveda", icon: <FaLeaf /> },
    { id: "HOMEOPATHIC", name: "Homeopathic", icon: <FaFlask /> },
    { id: "BABY & MOM CARE", name: "Baby & Mom Care", icon: <FaBaby /> },
    { id: "MEDICAL DEVICES", name: "Medical Devices", icon: <FaStethoscope /> },
    { id: "PERSONAL CARE", name: "Personal Care", icon: <FaUser /> },
    {
      id: "PROTEIN & FITNESS",
      name: "Protein & Fitness",
      icon: <FaDumbbell />,
    },
  ];

  const isItemInCart = (medicineId) => {
    return cartItems.some((item) => item.productID === medicineId);
  };

  // Define price ranges
  const priceRanges = [
    { id: "all", label: "All Prices", min: 0, max: Infinity },
    { id: "under-100", label: "Under ₹100", min: 0, max: 100 },
    { id: "100-500", label: "₹100 - ₹500", min: 100, max: 500 },
    { id: "500-1000", label: "₹500 - ₹1000", min: 500, max: 1000 },
    { id: "1000-2000", label: "₹1000 - ₹2000", min: 1000, max: 2000 },
    { id: "above-2000", label: "Above ₹2000", min: 2000, max: Infinity },
  ];

  useEffect(() => {
    const fetchMedicines = async () => {
      try {
        const response = await axios.get("https://api.swasthmitra.com/api/medicine");
        setMedicines(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch medicines. Please try again later.");
        setLoading(false);
      }
    };

    fetchMedicines();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (stickyRef.current) {
        const scrolled = window.scrollY > 100;
        setIsScrolled(scrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Update suggestions when search query changes
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setSuggestions([]);
      return;
    }

    const query = searchQuery.toLowerCase();
    const matchedMedicines = medicines.filter(medicine => 
      medicine.name?.toLowerCase().includes(query) || 
      medicine.brand?.toLowerCase().includes(query) || 
      medicine.salt?.toLowerCase().includes(query)
    );

    setSuggestions(matchedMedicines.slice(0, 10)); // Limit to 10 suggestions
    setShowSuggestions(true);
  }, [searchQuery, medicines]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleViewMore = () => {
    setVisibleMedicines((prev) => prev + 8);
  };

  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
    setVisibleMedicines(8); // Reset visible items when changing category
  };

  const handleSort = (value) => {
    setSortBy(value);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSuggestionClick = (medicine) => {
    setSearchQuery(medicine.name);
    setShowSuggestions(false);
    
    // Filter medicines based on the selected suggestion
    setSelectedCategory("all");
    setBrandFilter(medicine.brand || "all");
    setSalt(medicine.salt || "all");
  };

  // Get unique brands for filter
  const uniqueBrands = [
    ...new Set(medicines.map((medicine) => medicine.brand)),
  ];

  const uniqueSalts = [...new Set(medicines.map((medicine) => medicine.salt))];

  // Update FilterSection component
  const FilterSection = () => (
    <div className="filter-section1 horizontal-scroll">

      {/* <div className="filter-group">
        <label>Brand:</label>
        <select
          value={brandFilter}
          onChange={(e) => setBrandFilter(e.target.value)}
        >
          <option key="all-brands" value="all">
            All Brands
          </option>
          {uniqueBrands.map((brand) => (
            <option key={`brand-${brand}`} value={brand}>
              {brand}
            </option>
          ))}
        </select>
      </div> */}
<div className="filter-group">
        <label>Big Discount</label>
        <select
          value={discountSort}
          onChange={(e) => setDiscountSort(e.target.value)}
        >
          <option key="sort-default" value="default">
            Default
          </option>
          <option key="sort-discount" value="discount">
            Big Discount
          </option>
        </select>
      </div>

      <div className="filter-group">

        <label>Salt of your choice</label>
        <select value={salt} onChange={(e) => setSalt(e.target.value)}>
          <option key="all-salts" value="all">
            All Salts
          </option>
          {uniqueSalts.map((salt) => (
            <option key={`salt-${salt}`} value={salt}>
              {salt}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>Price Range:</label>
        <select
          value={selectedPriceRange}
          onChange={(e) => setSelectedPriceRange(e.target.value)}
          className="price-range-select"
        >
          {priceRanges.map((range) => (
            <option key={`price-${range.id}`} value={range.id}>
              {range.label}
            </option>
          ))}
        </select>
      </div>

      

      <div className="filter-group">
        <label>Sort By:</label>
        <select
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
        >
          <option key="sort-default" value="default">
            Default
          </option>
          <option key="sort-price-low" value="price-low">
            Price: Low to High
          </option>
          <option key="sort-price-high" value="price-high">
            Price: High to Low
          </option>
          <option key="sort-discount" value="discount">
            Highest Discount
          </option>
        </select>
      </div>

    </div>
  );

  // if (loading) return <div className="loading-spinner">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;

  let filteredMedicines = [...medicines]; // Create a copy to avoid mutating original

  // Apply search query filter
  if (searchQuery.trim() !== '') {
    const query = searchQuery.toLowerCase();
    filteredMedicines = filteredMedicines.filter(medicine => 
      medicine.name?.toLowerCase().includes(query) || 
      medicine.brand?.toLowerCase().includes(query) || 
      medicine.salt?.toLowerCase().includes(query)
    );
  }

  // Apply category filter
  if (selectedCategory !== "all") {
    filteredMedicines = filteredMedicines.filter(
      (medicine) => medicine.category === selectedCategory
    );
  }

  // Apply brand filter
  if (brandFilter !== "all") {
    filteredMedicines = filteredMedicines.filter(
      (medicine) => medicine.brand === brandFilter
    );
  }

  if (salt !== "all") {
    filteredMedicines = filteredMedicines.filter(
      (medicine) => medicine.salt === salt
    );
  }

  // Apply price range filter
  if (selectedPriceRange !== "all") {
    const selectedRange = priceRanges.find(
      (range) => range.id === selectedPriceRange
    );
    filteredMedicines = filteredMedicines.filter(
      (medicine) =>
        medicine.dealRate >= selectedRange.min &&
        medicine.dealRate <= selectedRange.max
    );
  }

  // Apply sorting - handle both discount sort and general sort
  if (discountSort === "discount") {
    // Apply discount sorting when discount filter is active
    filteredMedicines.sort((a, b) => {
      const discountA = a.mrp > 0 ? ((a.mrp - a.dealRate) / a.mrp) * 100 : 0;
      const discountB = b.mrp > 0 ? ((b.mrp - b.dealRate) / b.mrp) * 100 : 0;
      return discountB - discountA;
    });
  } else if (sortOrder !== "default") {
    // Apply general sorting when not default
    filteredMedicines.sort((a, b) => {
      switch (sortOrder) {
        case "price-low":
          return a.dealRate - b.dealRate;
        case "price-high":
          return b.dealRate - a.dealRate;
        case "name":
          return a.name.localeCompare(b.name);
        case "discount":
          const discountA = a.mrp > 0 ? ((a.mrp - a.dealRate) / a.mrp) * 100 : 0;
          const discountB = b.mrp > 0 ? ((b.mrp - b.dealRate) / b.mrp) * 100 : 0;
          return discountB - discountA;
        default:
          return 0;
      }
    });
  }
  // When both are "default", maintain original order from the API

  const handleAddToCart = async (medicine) => {
    // console.log(medicine);
    if (!USER) {
      toast.error("Please login to add items to cart");
      navigate('/login')
      return;
    }
    const cartItem = {
      productID: medicine._id,
      productName: medicine.name,
      dealRate: parseFloat(medicine.salePrice),
      productImage: medicine.imageUrl || medicine.imageUrls[0] || "",
      quantity: 1,
      batchNumber: medicine.batchNumber,
      brand: medicine.brand,
      packof: medicine.packOf,
      gst: medicine.gst,
      mrp: medicine.mrp,
      expiryDate: medicine.expiryDate,
    };

    try {
      await dispatch(
        addToCartAsync({
          userId: USER,
          productID: medicine._id,
          quantity: 1,
        })
      );
      dispatch(addToCart(cartItem));
      toast.success(`${medicine.name} added to cart!`);
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error("Failed to add item to cart");
    }
  };

  return (
    <div className="popular-category-page">
      <ToastContainer />
      <div className="page-header">
        <h2>All Medicine SEARCH</h2>
        <div className="search-container" style={{marginBottom: '1px'}}>
          <div className="search-filter-group" ref={searchRef}>
            <div className="search-input-container">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search medicines by salt, brand or name..."
                value={searchQuery}
                onChange={handleSearchChange}
                className="search-input"
                onFocus={() => setShowSuggestions(true)}
              />
            </div>
            {showSuggestions && suggestions.length > 0 && (
              <div className="suggestions-container">
                {suggestions.map((medicine) => (
                  <div 
                    key={medicine._id} 
                    className="suggestion-item"
                    onClick={() => handleSuggestionClick(medicine)}
                  >
                    <div className="suggestion-image">
                      <img src={medicine.imageUrl || medicine.imageUrls?.[0] || df} alt={medicine.name} />
                    </div>
                    <div className="suggestion-details">
                      <div className="suggestion-name">{medicine.name}</div>
                      <div className="suggestion-info">
                        <span className="suggestion-brand">{medicine.brand}</span>
                        {medicine.salt && <span className="suggestion-salt">{medicine.salt}</span>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div
        ref={stickyRef}
        className={`sticky-container ${isScrolled ? "scrolled" : ""}`}
      >
        {/* Categories Section */}
        <div className="categories-section">
          <div className="categories-row">
            {categories.map((category) => (
              <button
                key={category.id}
                className={`category-item ${
                  selectedCategory === category.id ? "active" : ""
                }`}
                onClick={() => handleCategorySelect(category.id)}
              >
                <span className="category-icon">{category.icon}</span>
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Add Filter Section here */}
        <FilterSection />
      </div>

      <div className="products-container">
        {/* Results Summary */}
        <div className="results-summary">
          Showing {Math.min(visibleMedicines, filteredMedicines.length)} of{" "}
          {filteredMedicines.length} products
        </div>

        {/* Medicines Section */}
        <div className="products-grid2">
          {filteredMedicines.slice(0, visibleMedicines).map((medicine) => (
            <div className="product-card" key={medicine._id}>
              <div className="image-wrapper">
                <Link to={`/product/${medicine._id}`} onClick={scrollToTop}>
                <img
  src={medicine.imageUrl || medicine.imageUrls?.[0] || df}
  alt={medicine.name || "Default Medicine"}
  className="allmedicine-image"
/>

                </Link>
                <button
                  className={`add-to-cart-button ${
                    cartItems.some((item) => item.productID === medicine._id)
                      ? "disabled"
                      : ""
                  }`}
                  onClick={() => {
                    if (
                      !cartItems.some((item) => item.productID === medicine._id)
                    ) {
                      handleAddToCart(medicine);
                    }
                  }}
                >
                  {cartItems.some((item) => item.productID === medicine._id)
                    ? "In Cart"
                    : "Add to Cart"}
                </button>
              </div>
              <div className="product-info2">
                <h4>
                  {medicine.name.length > 20
                    ? `${medicine.name.slice(0, 25)}...`
                    : medicine.name}
                </h4>
                <div className="sty"><p className="category-tag">{medicine.category}</p></div>
                <div className="price-info">
                  <span className="mrp2">₹{medicine.mrp}</span>
                  {/* <span className="deal-rate2">₹{medicine.dealRate}</span> */}
                  <span className="deal-rate2">
                    ₹{Math.round(medicine.dealRate)}
                  </span>
                  {medicine.dealRate < medicine.mrp && (
                    <span className="discount2">
                      {Math.round(
                        ((medicine.mrp - medicine.dealRate) / medicine.mrp) *
                          100
                      )}
                      % OFF
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {visibleMedicines < filteredMedicines.length && (
          <button className="view-more-button" onClick={handleViewMore}>
            View More
          </button>
        )}
      </div>
    </div>
  );
};

export default AllMeds;